import React, { useEffect } from 'react';
import { Link } from "react-router";
import '../styles/NotFoundPage.css';

interface ErrorPageProps {
  status?: number;
  title?: string;
  message?: string;
  onRetry?: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
  status = 500,
  title = 'Something went wrong',
  message = "An unexpected error occurred. Please try again, or head back to the home page.",
  onRetry,
}) => {
  useEffect(() => {
    document.title = `${title} | Atlanta Executive Property Management`;
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex';
    document.head.appendChild(robots);
    return () => {
      document.head.removeChild(robots);
    };
  }, [title]);

  return (
    <main className="error-page">
      <div className="error-inner">
        <span className="error-num">{status}</span>
        <h1>{title}</h1>
        <p>{message}</p>
        <div className="error-cta">
          {onRetry && (
            <button type="button" className="primary error-btn" onClick={onRetry}>
              Try again
            </button>
          )}
          <Link to="/" className={onRetry ? 'secondary' : 'primary'}>
            &larr; Back to home
          </Link>
          <Link to="/contact" className="secondary">Contact us</Link>
        </div>
      </div>
    </main>
  );
};

export default ErrorPage;
